/* eslint-disable camelcase */
import http from '@/base/api/public'

let apiUrl = require('@/../config/sysConfig')


// 初期化
export const home = () => {
  return http.requestQuickGet(apiUrl.apiUrl_Initialization)
}
// 检索处理
export const k_0006 = (params) => {
  return http.requestQuickGet('api/v1/staff/attendances' + '/from/' + params.dateFrom + '/end/' + params.dateTo)
}




// WEBPACK FOOTER //
// ./src/module/api/k_0006.js